import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatSort, MatPaginatorIntl, Sort, PageEvent } from '@angular/material';
import { NgForm } from '@angular/forms';
import { StatesService } from '../../services/states/states.service';
import { ParComplaintsRegionstatemapService } from '../../services/par-complaints-regionstatemap/par-complaints-regionstatemap.service';
import { FormControl } from '@angular/forms';
@Component({
  selector: 'app-par-complaints-region-state-mapping',
  templateUrl: './par-complaints-region-state-mapping.component.html',
  styleUrls: ['./par-complaints-region-state-mapping.component.css']
})
export class ParComplaintsRegionStateMappingComponent implements OnInit {
  statesControl = new FormControl;
  regionsList = ['1', '2', '3', '4'];
  statesList = [];
  regionsData: any;
  data = {
    Regions: this.regionsList[0],
    States: []
  }
  errorMessage: string = '';
  errorEnable: boolean = false;
  displayedColumns = ['Regions', 'States'];
  editLocalData: any;
  regionStateMapList: any;
  statesListByRegionId: any;
  defaultRegion;
  regionId;
  loginId;
  formStatesData;
  regionOneStates;
  regionTwoStates;
  regionThreeStates;
  regionFourStates;
  dataSource: MatTableDataSource<ViewRegionStateMapData>;
  MatchedStates = [];
  message;

  constructor(public statesService: StatesService, public regionStateMappingService: ParComplaintsRegionstatemapService) {
  }

  ngOnInit() {
    this.getAllStates();
    this.getRegionStatesTable();
    this.defaultRegion = this.data.Regions[0];
    this.getStatesByRegionId(this.defaultRegion);
    this.loginId = localStorage.getItem('loginID')

  }

  onFormSubmit(form: NgForm) {
    let message;
    this.editLocalData = form.value;
    this.regionId = this.editLocalData.Regions;
    this.formStatesData = this.editLocalData.States;
    let validation;
    if (this.regionId == 1) {
      this.statesCompare(this.regionId, this.formStatesData);
    } else if (this.regionId == 2) {
      this.statesCompare(this.regionId, this.formStatesData);
    } else if (this.regionId == 3) {
      this.statesCompare(this.regionId, this.formStatesData);
    } else if (this.regionId == 4) {
      this.statesCompare(this.regionId, this.formStatesData);
    }
    if (this.MatchedStates.length != 0) {
      this.errorMessage = this.MatchedStates + " State(s) belongs to other region(s)";
      this.errorEnable = true;
    } else {
      this.regionsData = {
        "States": this.editLocalData.States,
        "UpdatedBy": this.loginId
      };

      this.regionStateMappingService.updateRegionStateMapping(this.regionsData, this.regionId).subscribe(res => {
        this.getRegionStatesTable();
        this.errorEnable = false;
      },
        err => {
          this.errorMessage = "Error occurred while updating States : " + err;
          this.errorEnable = true;
        });
    }

  }

  statesCompare(regionId, formStates) {
    this.MatchedStates = [];
    if (regionId == 1) {
      formStates.forEach(state => {
        if (this.regionTwoStates.includes(state)) {
          this.MatchedStates.push(state);
        }
        if (this.regionThreeStates.includes(state)) {
          this.MatchedStates.push(state);
        }
        if (this.regionFourStates.includes(state)) {
          this.MatchedStates.push(state);
        }
      })
    } else if (regionId == 2) {
      formStates.forEach(state => {
        if (this.regionOneStates.includes(state)) {
          this.MatchedStates.push(state);
        }
        if (this.regionThreeStates.includes(state)) {
          this.MatchedStates.push(state);
        }
        if (this.regionFourStates.includes(state)) {
          this.MatchedStates.push(state);
        }
      })
    } else if (regionId == 3) {
      formStates.forEach(state => {
        if (this.regionOneStates.includes(state)) {
          this.MatchedStates.push(state);
        }
        if (this.regionTwoStates.includes(state)) {
          this.MatchedStates.push(state);
        }
        if (this.regionFourStates.includes(state)) {
          this.MatchedStates.push(state);
        }
      })
    } else if (regionId == 4) {
      formStates.forEach(state => {
        if (this.regionOneStates.includes(state)) {
          this.MatchedStates.push(state);
        }
        if (this.regionThreeStates.includes(state)) {
          this.MatchedStates.push(state);
        }
        if (this.regionTwoStates.includes(state)) {
          this.MatchedStates.push(state);
        }
      })
    }
  }


  getAllStates() {
    this.statesService.getStates().subscribe(res => {
      if (res.States) {
        this.statesList = res.States;
      }
    },
      err => {
        this.errorMessage = "View States Service : " + err;
        this.errorEnable = true;
      });
  }

  getStatesByRegionId(regionId) {
    this.regionStateMappingService.getStatesMappingByRegionId(regionId).subscribe(res => {
      if (res.Regions) {
        this.statesListByRegionId = [];
        this.statesListByRegionId = res.Regions[0].States;
        this.data.States = res.Regions[0].States;
      }
    },
      err => {
        this.errorMessage = "View States Service : " + err;
        this.errorEnable = true;
      });
  }

  getRegionStatesTable() {
    this.regionStateMappingService.getRegionStatesTableData().subscribe(res => {
      if (res.Regions) {
        res.Regions.forEach(region => {
          switch (region.RegionId) {
            case 1:
              this.regionOneStates = region.States;
              break;
            case 2:
              this.regionTwoStates = region.States;
              break;
            case 3:
              this.regionThreeStates = region.States;
              break;
            case 4:
              this.regionFourStates = region.States;
              break;
          }
        });
        this.regionStateMapList = [];
        this.regionStateMapList = res.Regions;
        this.dataSource = new MatTableDataSource(this.regionStateMapList);
      }
    },
      err => {
        this.errorMessage = "View region state map Service : " + err;
        this.errorEnable = true;
      });
  }

  regionChange(event) {
    if (event.value) {
      this.getStatesByRegionId(event.value);
      this.errorEnable = false;
    }
  }


}



export interface ViewRegionStateMapData {
  RegionId: String;
  States: String;

}



// WEBPACK FOOTER //
// ./src/app/components/par-complaints-region-state-mapping/par-complaints-region-state-mapping.component.ts